import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import invoiceReducer from './slices/invoiceSlice';
import aboReducer from './slices/aboSlice';
import userReducer from './slices/userSlice';
import photoReducer from './slices/photoSlice';
import aiInstructionReducer from './slices/aiInstructionSlice';
import emailAccountReducer from './slices/emailAccountSlice';
import myEmailsReducer from './slices/myEmailsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    invoices: invoiceReducer,
    abo: aboReducer,
    users: userReducer,
    photo: photoReducer,
    aiInstructions: aiInstructionReducer,
    emailAccounts: emailAccountReducer,
    myEmails: myEmailsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 